// Initialize Podcasts Recent Slider
(function() {
    'use strict';

    let podcastsRecentSwiper = null;
    let initAttempts = 0;
    const maxAttempts = 20;

    function initPodcastsRecentSlider(resetAttempts) {
        if (resetAttempts) {
            initAttempts = 0;
        }
        initAttempts++;

        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initPodcastsRecentSlider(false);
                }, 100);
            } else {
                console.error('Swiper failed to load after multiple attempts');
            }
            return;
        }

        // Initialize podcasts recent slider
        const podcastsRecentSection = document.querySelector('.podcast-recent');
        if (!podcastsRecentSection) {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initPodcastsRecentSlider(false);
                }, 100);
            }
            return;
        }

        const slider = podcastsRecentSection.querySelector('.podcast-recent__slider');
        const prevBtn = podcastsRecentSection.querySelector('.podcast-recent__nav-btn--prev');
        const nextBtn = podcastsRecentSection.querySelector('.podcast-recent__nav-btn--next');

        if (!slider) {
            return;
        }

        // Check if slider already has slides
        const slides = slider.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
            return;
        }

        // Destroy existing instance if any
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
            podcastsRecentSwiper = null;
        }

        try {
            podcastsRecentSwiper = new Swiper(slider, {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: false,
                speed: 600,
                grabCursor: true,
                watchOverflow: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                    disabledClass: 'podcast-recent__nav-btn--disabled',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.15,
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                },
                on: {
                    init: function() {
                        updateNavButtons();
                    },
                    slideChange: function() {
                        updateNavButtons();
                    },
                    reachEnd: function() {
                        updateNavButtons();
                    },
                    reachBeginning: function() {
                        updateNavButtons();
                    },
                },
            });

            function updateNavButtons() {
                if (!podcastsRecentSwiper) return;

                if (prevBtn) {
                    if (podcastsRecentSwiper.isBeginning) {
                        prevBtn.classList.add('podcast-recent__nav-btn--disabled');
                        prevBtn.disabled = true;
                    } else {
                        prevBtn.classList.remove('podcast-recent__nav-btn--disabled');
                        prevBtn.disabled = false;
                    }
                }
                if (nextBtn) {
                    if (podcastsRecentSwiper.isEnd) {
                        nextBtn.classList.add('podcast-recent__nav-btn--disabled');
                        nextBtn.disabled = true;
                    } else {
                        nextBtn.classList.remove('podcast-recent__nav-btn--disabled');
                        nextBtn.disabled = false;
                    }
                }
            }
        } catch (error) {
            console.error('Error initializing podcasts recent slider:', error);
        }
    }

    // Make function globally available
    window.initPodcastsRecentSlider = initPodcastsRecentSlider;

    // Wait for window load to ensure all scripts are loaded
    if (window.addEventListener) {
        window.addEventListener('load', function() {
            setTimeout(function() {
                initPodcastsRecentSlider(false);
            }, 100);
        });
    }

    // Also try when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(function() {
                initPodcastsRecentSlider(false);
            }, 200);
        });
    } else {
        setTimeout(function() {
            initPodcastsRecentSlider(false);
        }, 200);
    }
})();

// Podcasts Filters
(function() {
    'use strict';

    const form = document.querySelector('.blog-filters__form');
    if (!form) return;

    const podcastContent = document.querySelector('.podcast-content');
    if (!podcastContent) return;

    // Check if AJAX is available
    if (typeof evona === 'undefined' || !evona.ajaxUrl || !evona.podcastsNonce) {
        // Fallback to regular form submission
        const searchInput = form.querySelector('.blog-filters__search-input');
        if (searchInput) {
            let searchTimeout;
            searchInput.addEventListener('input', function() {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(function() {
                    form.submit();
                }, 500);
            });

            searchInput.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    clearTimeout(searchTimeout);
                    form.submit();
                }
            });
        }
        return;
    }

    // Save initial content for restoration
    let initialContent = podcastContent.innerHTML;

    // Loading state
    let isLoading = false;

    /**
     * Check if filters are cleared (all default values)
     */
    function areFiltersCleared() {
        const searchInput = form.querySelector('.blog-filters__search-input');
        const searchValue = searchInput ? searchInput.value.trim() : '';
        return searchValue === '';
    }

    /**
     * Perform AJAX filter request
     */
    function performFilterRequest(paged) {
        if (isLoading) return;

        const searchInput = form.querySelector('.blog-filters__search-input');
        const searchValue = searchInput ? searchInput.value.trim() : '';
        const pageNumber = paged || 1;

        // If filters are cleared and page is 1, restore initial content
        if (areFiltersCleared() && pageNumber === 1) {
            podcastContent.innerHTML = initialContent;
            if (typeof window.initPodcastsRecentSlider === 'function') {
                window.initPodcastsRecentSlider(true);
            }
            attachPaginationHandlers();
            return;
        }

        isLoading = true;
        podcastContent.style.opacity = '0.5';
        podcastContent.style.pointerEvents = 'none';

        // Prepare form data
        const formData = new FormData();
        formData.append('action', 'evona_podcasts_filter');
        formData.append('nonce', evona.podcastsNonce);
        formData.append('search', searchValue);
        formData.append('paged', pageNumber);

        // Send AJAX request
        fetch(evona.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(function(data) {
            isLoading = false;
            podcastContent.style.opacity = '1';
            podcastContent.style.pointerEvents = 'auto';

            if (data.success && data.data && data.data.content) {
                podcastContent.innerHTML = data.data.content;
                if (typeof window.initPodcastsRecentSlider === 'function') {
                    // Reset attempts when reinitializing after AJAX
                    window.initPodcastsRecentSlider(true);
                }
                attachPaginationHandlers();
            } else {
                console.error('AJAX error:', data);
                // Restore initial content on error
                podcastContent.innerHTML = initialContent;
                if (typeof window.initPodcastsRecentSlider === 'function') {
                    window.initPodcastsRecentSlider(true);
                }
                attachPaginationHandlers();
            }
        })
        .catch(function(error) {
            isLoading = false;
            podcastContent.style.opacity = '1';
            podcastContent.style.pointerEvents = 'auto';
            console.error('AJAX request failed:', error);
            // Restore initial content on error
            podcastContent.innerHTML = initialContent;
            if (typeof window.initPodcastsRecentSlider === 'function') {
                window.initPodcastsRecentSlider(true);
            }
            attachPaginationHandlers();
        });
    }

    /**
     * Attach click handlers to pagination links
     */
    function attachPaginationHandlers() {
        const paginationLinks = podcastContent.querySelectorAll('.podcast-pagination a');
        paginationLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                const href = this.getAttribute('href');
                if (!href) return;

                // Extract page number from URL
                let pageNumber = 1;
                const pageMatch = href.match(/[?&]paged=(\d+)/);
                if (pageMatch) {
                    pageNumber = parseInt(pageMatch[1], 10);
                } else {
                    const pageMatch2 = href.match(/\/page\/(\d+)\//);
                    if (pageMatch2) {
                        pageNumber = parseInt(pageMatch2[1], 10);
                    }
                }

                // Scroll to top of podcast content
                podcastContent.scrollIntoView({ behavior: 'smooth', block: 'start' });

                // Perform filter request with page number
                performFilterRequest(pageNumber);
            });
        });
    }

    // Handle search input with debounce
    const searchInput = form.querySelector('.blog-filters__search-input');
    if (searchInput) {
        let searchTimeout;
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function() {
                performFilterRequest();
            }, 500);
        });

        // Submit on Enter key
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(searchTimeout);
                performFilterRequest();
            }
        });
    }

    // Prevent default form submission
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        performFilterRequest(1);
    });

    // Attach pagination handlers on initial load
    attachPaginationHandlers();
})();
